import { NewReactModal } from '../components/NewReactModal';
import { createEntry } from '../helpers/entries';

createEntry({
  component: NewReactModal,
  name: 'NewReactModal',
});
